module.exports = __webpack_public_path__ + "img/bg_kk.173c020e.svg";